import {Action} from '@ngrx/store';
import {PositionDTO, SelectedPositionsDTO} from '@staff-app/models/positionDTO';

export enum PositionActionTypes {
  GetAvailableAndSelectedPositions = '[Position] Get Available And Selected Positions',
  GetAvailableAndSelectedPositionsSuccessful = '[Position] Get Available And Selected Positions Successful',
  SaveSelectedPositions = '[Position] Save Selected Position',
  SaveSelectedPositionsSuccessful = '[Position] Save Selected Position Successful',
  NavigateAway = '[Position] Navigate Away'
}

export class GetAvailableAndSelectedPositions implements Action {
  readonly type = PositionActionTypes.GetAvailableAndSelectedPositions;

  constructor(public payload: number) {}
}
export class GetAvailableAndSelectedPositionsSuccessful implements Action {
  readonly type =
    PositionActionTypes.GetAvailableAndSelectedPositionsSuccessful;

  constructor(public payload: PositionDTO[]) {}
}

export class SaveSelectedPositions implements Action {
  readonly type = PositionActionTypes.SaveSelectedPositions;

  constructor(
    public payload: SelectedPositionsDTO,
    public isEditMode = false
  ) {}
}
export class SaveSelectedPositionsSuccessful implements Action {
  readonly type = PositionActionTypes.SaveSelectedPositionsSuccessful;
  constructor(public payload: SelectedPositionsDTO) {}
}
export class NavigateAway implements Action {
  readonly type = PositionActionTypes.NavigateAway;

  constructor() {}
}
export type PositionActions =
  | GetAvailableAndSelectedPositions
  | GetAvailableAndSelectedPositionsSuccessful
  | SaveSelectedPositions
  | SaveSelectedPositionsSuccessful
  | NavigateAway;
